<template>
  <ul class="overflow-auto pt-1" role="list" :style="{maxHeight: allowClick ? '300px' : '150px'}">
    <li v-for="(item, index) in docHistory" :key="index" @click="handleClick(item)" :class="[clickDocnum(item.DocNum) && 'marker-disabled',
    clickDocnum(item.DocNum) && ['Entrega', 'Factura'].includes(item.title) ? 'hover-element' : null
    ]"
      :style="clickDocnum(item.DocNum) && ['Entrega', 'Factura'].includes(item.title) ? 'cursor: pointer;' : 'cursor: default;'">
      <div class="position-relative pr-4 py-1">
        <div class="d-flex justify-content-between align-items-center" :title="item.From_DocNum &&
          `Creado desde ${findIn(
            docHistory,
            'DocNum',
            item.From_DocNum,
            'title'
          )} #${item.From_DocNum}`
          ">
          <div class="d-flex align-items-center">
            <p :class="[
              'm-0 text-xs font-weight-normal',
              clickDocnum(item.DocNum) ? '' : 'font-weight-bold text-default',
            ]">
              {{ item.title }}
              <span>#{{ item.DocNum }}</span>
            </p>
            <p class="m-0 text-xs text-gray font-italic pl-2">
              {{ formatDateTime(item.DocDate, item.DocTime) }}
            </p>
          </div>
          <span class="text-xs">
            <badge :type="item.color">{{ item.status }}</badge>
          </span>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import moment from "moment";
import axios from "axios";
export default {
  name: "DocumentHistory",
  props: {
    docNum: {
      type: String,
      required: true,
    },
    table: {
      type: String,
      required: true,
      // OQUT - Quotations
      // ORDR - Sales Orders
      // ODLN - Deliveries
      // OINV - Invoices
    },
    allowClick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      HANA_URL: process.env.VUE_APP_HANA_URL,
      data: [
        {
          title: "Cotización",
          table: "OQUT",
          groupName: "Quotations",
        },
        {
          title: "Pedido",
          table: "ORDR",
          groupName: "Orders",
        },
        {
          title: "Entrega",
          table: "ODLN",
          groupName: "Deliveries",
        },
        {
          title: "Factura",
          table: "OINV",
          groupName: "Invoices",
        },
      ],
      statusOptions: [
        { value: "O", label: "Abierto", color: "primary" },
        { value: "C", label: "Cerrado", color: "light" },
        { value: "Y", label: "Cancelado", color: "danger" },
      ],
      docHistory: null,
    };
  },
  created() {
    this.getSalesHistory();
  },
  methods: {
    findIn(options, optKey, valToFind, showKey) {
      if (!options) {
        return null;
      }
      const item = options.find((x) => x[optKey] === valToFind);
      return item ? (showKey ? item[showKey] : item) : null;
    },
    getSalesHistory() {
      axios
        .get(
          `${this.HANA_URL}/api/sales/history?table=${this.table}&doc_num=${this.docNum}`
        )
        .then((res) => {
          if (!res.data.errors) {
            let fullResult, newDocNum, newCode;
            if(['OINV', 'ODLN', 'ORDR'].includes(this.table)){
              if(res.data.results.Quotations.length){
                newDocNum = res.data.results.Quotations[0].DocNum;
                newCode = 'OQUT'; // Quotation
              } else {
                if(this.table === 'ORDR'){
                  fullResult = res.data.results;
                } else if(res.data.results.Orders.length){
                  newDocNum = res.data.results.Orders[0].DocNum;
                  newCode = 'ORDR' // Order
                }
              }
            } else {
              fullResult = res.data.results; 
            }
            if(newDocNum){

              axios.get(`${this.HANA_URL}/api/sales/history?table=${newCode}&doc_num=${newDocNum}`)
              .then(res => {
                fullResult = res.data.results;
                this.formatDocHistory(fullResult)
              }).catch(err => {
                console.error(err);
                this.$emit("result", []); 
              })
            } else if(fullResult){
              this.formatDocHistory(fullResult)
            } else {
              this.$emit("result", []); 
            }
          } else {
            console.error("Error", res.data.errors);
            this.$emit("result", []); 
          }
        })
        .catch((err) => {
          console.error(err);
          this.$emit("result", []); 
        });
    },
    formatDocHistory(docHistory) {
      this.docHistory = [];
      this.data
        .map((doc) => doc.groupName)
        .forEach((x) => {
          let currentGroup = docHistory[x].map((y) => {
            let status = y.Cancelled === "Y" ? "Cancelado" : this.statusOptions.find((x) => x.value === y.Status).label;
            return {
              ...y,
              title: this.data.find((y) => y.groupName === x).title,
              status: status,
              color: this.statusOptions.find((y) => y.label === status).color,
            };
          });
          this.docHistory = [...this.docHistory, ...currentGroup];
        });
        this.docHistory = this.docHistory.filter(x => {
          const docNum = parseInt(this.docNum);
          return x.Cancelled === 'N' || x.DocNum === docNum
        })
        this.$emit("result", this.docHistory);
    },
    formatDateTime(date, time) {
      const formatDate = moment(date).format("YYYY-MM-DD");
      const timeStr = time.toString().padStart(4, '0');
      const formatTime = moment(timeStr, "HHmm").format("HH:mm");
      return moment(`${formatDate} ${formatTime}`).format("YYYY-MM-DD HH:mm");
    },
    handleClick(item) {
      if (this.clickDocnum(item.DocNum) && ['Entrega', 'Factura'].includes(item.title)) {
        if (item.title === "Factura") {
          this.$router.push(`/invoice/${item.DocNum}`);
          this.$emit("reload");
        } else if (item.title === "Entrega") {
          this.$router.push(`/delivery/${item.DocNum}`);
          this.$emit("reload");
        }
      }
    },
    clickDocnum(itemDocNum) {
      return parseInt(itemDocNum) !== parseInt(this.docNum) || this.allowClick;
    }
  },
};
</script>

<style lang="scss" scoped>
li.marker-disabled::marker {
  color: #c9ced3;
}

.hover-element:hover {
  color: #5e72e4;
}

li.hover-element:hover::marker {
  color: #5e72e4;
}
</style>
